<input type="date" [attr.min]="today" class="ml-4 text-white text-center bg-cliking_blue text-base px-1 rounded-md" (change)="update($event)" [(ngModel)]="displayValue" >
